import logger from '@goldcast/logger';
import { Auth } from 'aws-amplify';

/**
 * Updates the custom:password_last_set Cognito attribute for the given user.
 * Failures are logged but intentionally not re-thrown — the password change
 * has already succeeded at this point and the user must not be blocked.
 */
export async function updatePasswordLastSet(cognitoUser: any): Promise<void> {
  const value = new Date()
    .toISOString()
    .replace('T', ' ')
    .replace(/\.\d+Z$/, ' +0000');
  try {
    await Auth.updateUserAttributes(cognitoUser, { 'custom:password_last_set': value });
  } catch (err) {
    logger.warn('[cognito] Failed to update password_last_set attribute', err);
  }
}
